















import {Component, Vue} from 'vue-property-decorator';

@Component
export default class MaterialPractice2 extends Vue {}
